const Graph = require('./BaseGraph')

module.exports = class EventGraph extends Graph 
{
    constructor(apiDomain, path="event")
    {
        super(apiDomain, path)
    }

    clientEventsQuery(fields, params=null)
    {
        if (params)
            return { type: 'clientEvents', query: this.queryString('clientEvents', fields, params) }

        return { type: 'clientEvents', query: `query getClientEvents ($accountId: String, $privacy: Int) {
            clientEvents(accountId: $accountId, privacy: $privacy)
            ${this.queryFields(fields)}
        }` }
    }

    organizationEventsQuery(fields, params=null)
    {
        if (params)
            return { type: 'organizationEvents', query: this.queryString('organizationEvents', fields, params) }

        return { type: 'organizationEvents', query: `query getOrganizationEvents ($tags: [String] $privacy: Int) {
            organizationEvents(tags: $tags privacy: $privacy)
            ${this.queryFields(fields)}
        }` }
    }
}